import { render, staticRenderFns } from "./VerificationRecord.vue?vue&type=template&id=e52ff7e6&scoped=true&"
import script from "./VerificationRecord.vue?vue&type=script&lang=js&"
export * from "./VerificationRecord.vue?vue&type=script&lang=js&"
import style0 from "./VerificationRecord.vue?vue&type=style&index=0&id=e52ff7e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52ff7e6",
  null
  
)

export default component.exports